import { CompanyDetail, Workspace, UserRole } from 'types'
import { ALMANAC_CORE_WORKSPACE_ID } from './constants'

/**
 * Lightweight version of workspace utils for signup flow.
 * Avoids pulling in lodash dependency.
 */

export const isAlmanacCoreWorkspace = (workspaceId: Workspace['id']) => workspaceId === ALMANAC_CORE_WORKSPACE_ID

export const findPrivateWorkspaces = (workspaces?: Workspace[]) => {
  if (!workspaces) return []
  return workspaces?.filter((ws: Workspace) => !isAlmanacCoreWorkspace(ws.id))
}

/**
 * converts type CompanyDetail (often returned from a request) to the more generally used Workspace Type.
 * @param company: CompanyDetail
 * @returns workspace: Workspace
 */
export const companyDetailToWorkspace = (company: CompanyDetail): Workspace => {
  return {
    id: company.id,
    created_at: new Date().toISOString(),
    name: company.name,
    key: company.key,
    logo_url: company.logo_url,
    unpaid_articles_count: 0,
    guest_articles_count: 0,
    admin: true,
    super_admin: true,
    paying: false,
    invitation_token: company.invitation_token,
    invitation_token_enabled: company.invitation_token_enabled,
    invitation_token_expiration_days: company.invitation_token_expiration_days,
    show_portal: false,
    show_make_public: false,
    guest: false,
    is_new: false,
    homepage_doc_slug: null,
    homepage_doc: null,
    role: UserRole.MEMBER,
    show_all_handbooks: false,
    snippets_enabled: false,
    handbook_default_read_mode: false,
    workspace_domain: null,
    members_count: 1,
    payment_failed: false,
    auto_membership_domains: [],
    features: [],
    version_control_mode: {
      value: false,
      metadata: null,
    },
    allow_public_links: true,
    documentation_enabled: true,
    layers_enabled: true,
    can_start_free_trial: false,
    color_scheme: null,
    app_logo_url: null,
    image_library_project: company.image_library_project,
    is_virtual_marketer: false,
    is_virtual_marketer_onboarding_completed: false,
    show_virtual_marketer_upgrade: false,
    pause_autopilot_generate_at: null,
    pause_autopilot_publish_at: null,
    resume_autopilot_generate_at: null,
    resume_autopilot_publish_at: null,
    post_approval_enabled: false,
    is_ap_freemium: false,
    is_ap_freemium_brand_plan_set: false,
    is_campaigns: false,
    is_whitelabel: false,
    white_label_color: null,
    auto_reload_credits: false,
    auto_reload_limit: null,
  }
}
